<template v-if="user.data.firstName">
  <div class="user" v-if="locale.user">
    <h1 class="mr-0 mb-4">{{ user.firstName }} {{ user.lastName }}</h1>
    <div class="logo-info-container">
      <img src="../assets/startseite_hintergrund.jpg" alt="mobilistics" class="logo">
    </div>
    <div class="" v-if="paymentUpdated">
      <p>{{locale.user.changePaymentSuccess}}</p>
    </div>
    <div class="grid">
      <div class="error-wrapper">
        <errorMessages v-for="error in errors.all()" v-bind:key="error.id" v-bind:error="error"/>
      </div>
      <form action="" class="authentication-form" @submit.prevent="submit">
        <div class="grid__column grid__column--xs-12 grid__column--sm-6">
          <div class="field">
            <label for="company">{{locale.user.company}}</label>
            <input type="text" :placeholder="locale.user.companyPlace" v-validate="'required|min:3'" :data-vv-as="locale.user.company" id="company" name="company" v-model="user.company">
          </div>
          <div class="field">
            <label for="lastName">{{locale.user.lastname}}</label>
            <input type="text" :placeholder="locale.user.lastnamePlace" v-validate="'required'" :data-vv-as="locale.user.lastname" id="lastName" name="lastName" v-model="user.lastName">
          </div>
          <div class="field">
            <label for="email">{{locale.user.email}}</label>
            <input type="email" :placeholder="locale.user.emailPlace" v-validate="'required|email'" :data-vv-as="locale.user.email" id="email" name="email" v-model="user.email">
          </div>
          <div class="field">
            <label for="street">{{locale.user.street}}</label>
            <input type="text" :placeholder="locale.user.streetPlace" v-validate="'required|min:5'" :data-vv-as="locale.user.street" id="street" name="street" v-model="user.street">
          </div>
          <div class="field">
            <label for="city">{{locale.user.city}}</label>
            <input type="text" :placeholder="locale.user.cityPlace" v-validate="'required|min:2'" :data-vv-as="locale.user.city" id="city" name="city" v-model="user.city">
          </div>
          <div class="field">
            <label for="mobile">{{locale.user.mobile}}</label>
            <input type="text" :placeholder="locale.user.mobilePlace" v-validate="{ required: true, regex: /^[\s\d]+$/ }" :data-vv-as="locale.user.mobile" id="mobile" name="mobile" v-model="user.mobile">
          </div>
        </div>
        <div class="grid__column grid__column--xs-12 grid__column--sm-6">
          <div class="field">
            <label for="firstName">{{locale.user.firstname}}</label>
            <input type="text" :placeholder="locale.register.firstnamePlace" v-validate="'required|min:3'" :data-vv-as="locale.user.firstname" id="firstName" name="firstName" v-model="user.firstName">
          </div>
          <div class="field">
            <label for="birthday">{{locale.user.birthday}}</label>
            <input type="text" :placeholder="locale.user.birthdayPlace" v-validate="'date_format:DD.MM.YYYY'" :data-vv-as="locale.user.birthday" id="birthday" name="birthday" v-model="user.birthday">
          </div>
          <div class="field">
            <label for="emailBilling">{{locale.user.emailBilling}}</label>
            <input type="email" :placeholder="locale.user.emailBillingPlace" v-validate="'required|email'" :data-vv-as="locale.user.emailBilling" id="emailBilling" name="emailBilling" v-model="user.emailBilling">
          </div>
          <div class="field">
            <label for="zipCode">{{locale.user.zip}}</label>
            <input type="number" :placeholder="locale.user.zipPlace" v-validate="'required|alpha_num|min:4'" :data-vv-as="locale.user.zip" id="zipCode" name="zipCode" v-model="user.zipCode">
          </div>
          <div class="field">
            <label for="tel">{{locale.user.phone}}</label>
            <input type="text" :placeholder="locale.user.phonePlace" v-validate="{ required: true, regex: /^[\s\d]+$/ }" :data-vv-as="locale.user.phone" id="tel" name="tel" v-model="user.tel">
          </div>
          <div class="field">
            <button type="submit" class="button">{{locale.user.buttonText}}</button>
          </div>
        </div>
      </form>
      <button class="button" @click="changePayment">{{locale.user.changePayment}}</button>
    </div>

    <form action="" class="authentication-form" @submit.prevent="submit">

      <div class="left-field">

      </div>

      <div class="right-field">

      </div>

      <div class="left-field">

      </div>

      <div class="right-field">

      </div>

      <div class="left-field">

      </div>

      <div class="right-field">

      </div>

      <div class="left-field">

      </div>

      <div class="right-field">

      </div>

      <div class="left-field">

      </div>

      <div class="right-field">

      </div>

      <div class="left-field">

      </div>

      <div class="right-field">

      </div>
    </form>
  </div>
</template>

<script>

import { mapState } from 'vuex'
import errorMessages from '../utils/errorMessages.vue'

export default {
  name: 'User',
  components: { errorMessages },
  computed: {
    ...mapState(['locale']),
    ...mapState({
      user: state => state.user.user,
      loadingState: state => state.loadingState
    })
  },
  data: function () {
    return {
      buttonText: 'Update',
      paymentUpdated: false
    }
  },
  created () {
    if (this.$route.params.orderID && this.$route.params.paymentMethod && this.$route.params.paymentInstrumentID) {
      this.updatePayment(this.$route.params.orderID, this.$route.params.paymentMethod, this.$route.params.paymentInstrumentID)
    }
  },
  methods: {
    submit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.buttonText = 'Loading'
          this.$store.dispatch('user/updateUser', this.user).then((response) => {
            this.$store.dispatch('user/getUser')
            this.buttonText = 'Success'
            console.log(response)
          }).catch((error) => {
            console.log(error)
            this.buttonText = 'Error'
          })
        }
      })
    },
    changePayment () {
      this.$store.dispatch('user/changePayment').then((response) => {
        window.location.replace(response.data)
      })
    },
    updatePayment (orderID, paymentMethod, paymentInstrumentID) {
      let orderSplit = orderID.split('-')
      let userID = orderSplit[1]
      let data = {
        'user': {
          'id': userID
        },
        'payment': {
          'paymentMethod': paymentMethod,
          'paymentInstrumentID': paymentInstrumentID,
          'orderID': orderID
        }
      }
      this.$store.dispatch('user/confirmPayment', data).then((response) => {
        this.paymentUpdated = response.status === 200
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/User.vue